import React, { FC } from 'react';

import './NumberedBadge.scss';

interface INumberedBadgeProps {
	number: string;
}

export const NumberedBadge: FC<INumberedBadgeProps> = ({ number }) => {
	return (
		<div aria-label={`Element ${number}`} className="numbered-badge">
			{number}
		</div>
	);
};
